<template>
  <div class="wrapper">
    <div class="filterWrapper___1wvrf">
      <div class="filterItem___3bwcm">
        <span class="title___1vMKn">分类选择：</span>
        <div class="filterRight___24f-6">
          <span
            v-for="(item, index) in allList"
            :key="item.egId"
            @click="egListTab(item, index)"
            class="itemText___1N3zE"
            :class="item.isSelect ? 'itemActive___u02fW' : ''"
          >
            {{ item.egName }}
          </span>
        </div>
        <!--<div class="btn_sel">-->
        <!--<span  @click="toMore(0)" class="resize">重置</span>-->
        <!--<span  @click="toMore(1)" class="query">查询</span>-->
        <!--</div>-->
        <div class="search_con">
          <span style="color: #ffb441"></span>
          <div>
            <div class="search___1FrwO">
              <el-input
                type="text"
                class="searchBox___joiqa"
                placeholder="请输入视频名称/讲师姓名"
                v-model="keyword"
                @keydown.enter.native="keyDown"
              ></el-input>
              <div class="iconWrapper___3GNet" @click="toMore()">
                <span class="icon iconfont" style="color: #ffffff"
                  >&#xe633;</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content___1ZfD3" v-if="!isShow">
      <div class="banner">
        <i-banner :list="imgList" :height="392"></i-banner>
      </div>
    </div>

    <div class="container" v-if="isvideo">
      <div v-if="!isShow">
        <div class="title_type">
          <span style="color: #a5c241">最新</span>
        </div>
        <i-videolist
          :video_newest="video_newest"
          v-on:success="success"
        ></i-videolist>

        <div class="title_type">
          <span style="color: #ffb441">最热</span>
        </div>
        <i-videolist
          :video_newest="video_hottest"
          v-on:success="success"
        ></i-videolist>
      </div>

      <div>
        <div class="title_type">
          <span style="color: #ffb441">全部视频</span>
        </div>
        <div>
          <i-videolist :video_newest="videos"></i-videolist>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/style/font1/iconfont.css";
import iBanner from "../container/banner";
import iVideolist from "../container/videoList";
import iSearch from "../container/search";
import bus from "../bus/index";
import alllive from "./alllist";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';

export default {
  data() {
    return {
      isvideo: true,
      activeindex: "first",
      key: "",
      video_newest: [],
      video_hottest: [],
      title: "",
      keyword: "",
      type: "",
      morenew: "",
      allList: [],

      imgList: [],
      isShow: false,
      list: {
        lives_will: [],
        lives_ing: [],
        lives_ed: [],
      },
      videos: [],
      uid: "",
      ra_wxUser: null,
      egid: "new",
    };
  },
  props: {},
  created() {},
  methods: {
    keyDown(e) {
      if (e.keyCode == 13) {
        //用户点击了enter触发
        this.toMore();
        console.log("用户按下了enter操作");
      }
    },
    toMore() {
      let eglist = this.allList.filter((v) => v.isSelect);
      let eg_ids = [];
      if (eglist.length) {
        eglist.map((item) => {
          eg_ids.push(item.egId);
        });
      }
      let params = {
        title: this.keyword,
        type: this.type,
        order: "",
        eg_ids: eg_ids,
      };
      this.isShow = true;
      console.log(params);
      this.$postHttp(AppSetting.baseUrl + "/video/list/condition", params).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.videos = data;
        }
      });
    },
    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    getData(type) {
      let params = {
        type: type,
      };
      this.$postHttp(AppSetting.baseUrl + "/video/list/condition", params).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.videos = data;
        }
      });
    },
    toDetails(id) {
      this.$router.push({
        name: "Details",
        query: { type: "live", liveId: id },
      });
    },
    egListTab(res, index) {
      let item = res;
      item.isSelect = !item.isSelect;
      this.$set(this.allList, index, item);
      setTimeout(() => {
        this.toMore();
      }, 500);
    },
    getList() {
      this.$postHttp(AppSetting.baseUrl + "/common/entgroup/info", {}).then((res) => {
        console.log("类型");
        console.log(res);
        if (res.data.code == 0) {
          let data = res.data.list;
          this.allList = data;
          this.allList.map((item) => {
            item.isSelect = false;
          });
        }
      });

      //img_type 轮播图列表 区分轮播图返回的是pc 还是移动的  1 移动 2 pc
      this.$postHttp(AppSetting.baseUrl + "/video/list", {
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "",
        img_type: 2,
      }).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.value;
          this.list = data;
          this.video_newest = data.video_newest;
          this.imgList = data.pictures;
          this.video_hottest = data.video_hottest;
        }
      });
    },

    none() {
      this.isShow = false;
    },
    screenOut() {
      this.isShow = !this.isShow;
    },
    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.ra_wxUser = loginUser;
      });
    },
    async signUp(status, index, lid) {
      localStorage.setItem("userLiveId", lid);
      localStorage.setItem("usertype", 1);
      if (await loginService.isNotLogin()) {
        this.login();
      } else if (
        (this.ra_wxUser.uPhone == null ||
          this.ra_wxUser.uPhone == "" ||
          this.ra_wxUser.uPhone == "null" ||
          this.ra_wxUser.uPhone == undefined) &&
        (this.ra_wxUser.uMail == null ||
          this.ra_wxUser.uMail == "" ||
          this.ra_wxUser.uMail == "null" ||
          this.ra_wxUser.uMail == undefined)
      ) {
        this.$router.push({
          name: "Login",
        });
      } else if (this.ra_wxUser.uPhone || this.ra_wxUser.uMail) {
        if (status == 0) {
          this.$postHttp("/live/appointment", {
            uid: this.ra_wxUser
              ? this.ra_wxUser.uId
                ? this.ra_wxUser.uId
                : ""
              : "",
            lid: lid,
          }).then((res) => {
            if (res.data.code == 0) {
              // this.text = '已预约';
              // this.sing = 1;
              // this.list.lives_will[index].lIsAppoint.$set()
              this.$set(this.list.lives_will[index], "lIsAppoint", 1);
              this.$set(
                this.list.lives_will[index],
                "lAppointNum",
                res.data.num
              );
              //参数：要改的对象、要改的key 、要改的值
              this.$message.success("预约成功");
            } else {
              this.$message.error("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {
                  // alert('取消')
                },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser
                      ? this.ra_wxUser.uId
                        ? this.ra_wxUser.uId
                        : ""
                      : "",
                    lid: lid,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.$set(this.list.lives_will[index], "lIsAppoint", 0);
                      this.$set(
                        this.list.lives_will[index],
                        "lAppointNum",
                        res.data.num
                      );
                      this.$message.success("取消成功");
                    } else {
                      this.$message.error("取消预约失败");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },

    containerScroll(e) {
      let container = document.documentElement;

      //文档内容实际高度（包括超出视窗的溢出部分）
      let scrollHeight = container.scrollHeight;
      //滚动条滚动距离
      let scrollTop = container.scrollTop;
      //窗口可视范围高度
      let clientHeight = container.clientHeight;
      localStorage.setItem("scrollTop", scrollTop);
      /*if (clientHeight + scrollTop >= scrollHeight - 80) {
        if (this.reachBottom) {
          console.log('onReachBottom')
          this.reachBottom = false;
          this.onReachBottom && this.onReachBottom();
        }
      } else {
        this.reachBottom || (this.reachBottom = true)
      }*/
    },
  },
  computed: {},
  components: {
    iBanner,
    iVideolist,
    iSearch,
    alllive,
  },
  async mounted() {
    this.ra_wxUser = await loginService.getLoginUser();
    console.log("----------------keepAliveChange:true");
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    console.log(sessionStorage.getItem("illumatype"));

    let container = document.documentElement;
    container.addEventListener("scroll", this.containerScroll, false);
  },
  beforeDestroy() {
    let container = document.documentElement;
    container.removeEventListener("scroll", this.containerScroll, false);
  },
  activated() {
    if (this.$route.meta.keepAliveChange || this.allList.length == 0) {
      this.isShow = false;
      this.keyword = "";

      this.allList = [];
      localStorage.setItem("scrollTop", 0);
      this.getList();

      this.list.lives_will = [];
      this.list.lives_ing = [];
      this.list.lives_ed = [];

      this.getData("");
      console.log("----------------keepAliveChange:true");
    } else {
      console.log("----------------keepAliveChange:false");
      let scrollTop = localStorage.getItem("scrollTop");
      document.documentElement.scrollTop = scrollTop ? scrollTop : 0;
    }
  },
};
</script>
<style scoped lang="scss">
.btn_sel {
  line-height: 30px;
  display: flex;

  span {
    width: 100px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    background: #ffb441;
    text-align: center;
    color: #ffffff;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
  }

  .resize {
    background: #e6e6ea;
  }

  .query {
    margin-left: 30px;
  }
}

.search_con {
  /*border: 1px solid #e6e6e6;*/
  margin-left: 30px;
  border-radius: 50%;

  .search___1FrwO {
    border: 1px solid #e6e6e6;
  }
}

.filterWrapper___1wvrf {
  margin-bottom: 20px;
  background: #fff;
  -webkit-box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
}

.search___1FrwO {
  position: relative;
  width: 296px;
  height: 36px;
  border-radius: 18px;
  /*background: #f2f2f2;*/
  background: #ffffff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;

  .searchBox___joiqa {
    outline: none;
    border: none;
    -ms-flex: 1 1;
    flex: 1 1;
    /*background: #f2f2f2;*/
    background: #ffffff;
    height: 36px;
    padding-left: 27px;
    font-size: 14px;
    color: #999;
    line-height: 20px;
    border-radius: 18px;
    -webkit-appearance: none;
  }

  .iconWrapper___3GNet {
    cursor: pointer;
    width: 56px;
    height: 36px;
    background-image: linear-gradient(-179deg, #ffb441, #ffb441);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;

    .icon {
      font-size: 26px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.filterItem___3bwcm {
  align-items: flex-start;
  width: 1280px;
  min-width: 1176px;
  border-bottom: 1px dashed #ebebeb;
  overflow: hidden;
  display: -ms-flexbox;
  display: flex;
  padding: 25px 0 6px;

  .title___1vMKn {
    font-size: 14px;
    float: left;
    line-height: 38px;
    color: #999;
    min-width: 70px;
    height: 30px;
    margin-right: 25px;
  }

  .filterRight___24f-6 {
    display: flex;
    line-height: 27px;
    flex-wrap: wrap; /*决定当排列不下时是否换行以及换行的方式*/
    span {
      font-size: 14px;
      cursor: pointer;
      padding: 2px 12px;
    }
  }

  .itemText___1N3zE {
    min-height: 20px;
    color: #333;
    margin-right: 8px;
    cursor: pointer;
    margin-bottom: 10px;
  }

  .itemActive___u02fW {
    border-radius: 16px;
    background-color: #ffb441;
    color: #fff;
    text-align: center;
  }
}

.wrapper {
  width: 100%;
  min-height: 88vh;
  min-width: 1280px;
}

.qcode {
  position: fixed;
  width: 1rem;
  height: 1rem;
  /*border-radius: 50%;*/
  bottom: 1.5rem;
  right: 0.1rem;
}

.abc {
  position: relative;
}

.abc img {
  display: block;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  /*width: 7rem;*/
  /*margin: 0.25rem;*/
}

.search {
  height: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0 0.3rem;
  box-sizing: border-box;
  background: #f7f7f7;

  > img {
    width: 2.79rem;
    height: 0.38rem;
  }

  > div {
    display: flex;
    width: 3.8rem;
    height: 0.7rem;
    border: 1px solid #dbdbdb;
    padding-left: 0.2rem;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 10px;
    margin-left: 0.32rem;

    input {
      width: 3rem;

      border: none;
      outline: none;
    }

    input::placeholder {
      color: #999999;
    }

    > div {
      width: 0.6rem;
      height: 0.68rem;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffb441;

      img {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}

.list___wypX_ {
  background: #f7f7f7;
}

.menus {
  display: flex;
  width: 100%;
  overflow-x: scroll;
  height: 2rem;
  padding-top: 0.18rem;
  box-sizing: border-box;

  li {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
      width: 1.1rem;
      height: 1.1rem;
      margin-bottom: 0.02rem;
    }

    span {
      color: #333333;
      text-align: center;
      padding: 0 0.1rem;
      box-sizing: border-box;
      width: 100%;
      font-size: 0.32rem;
      text-overflow: ellipsis; /*这就是省略号喽*/
      overflow: hidden; /*设置超过的隐藏*/
      white-space: nowrap; /*设置不折行*/
    }
  }
}

.banner {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05),
    -3px 0 5px rgba(0, 0, 0, 0.05);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05), -3px 0 5px rgba(0, 0, 0, 0.05);
  /*margin: 0.21rem auto 0.4rem;*/
  .swiper-container {
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.container {
  min-width: 1280px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.title_type {
  display: flex;
  align-items: center;
  /*height: 0.35rem;*/
  justify-content: space-between;
  /*margin-bottom: 0.2rem;*/
  font-size: 26px;
  font-weight: 500;
  margin-top: 40px;
  padding-right: 35px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-size: 12px;
      color: #333333;
      cursor: pointer;
    }
  }

  > span:nth-of-type(1) {
    color: #333333;
    font-size: 26px;
  }

  img {
    width: 10px;
    height: 15px;
    margin-left: 7px;
  }
}

.banner {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05),
    -3px 0 5px rgba(0, 0, 0, 0.05);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05), -3px 0 5px rgba(0, 0, 0, 0.05);
}

.livesing {
  background: #ffffff;
  width: 100%;
  min-width: 1280px;

  > div {
    width: 1280px;
    min-width: 1280px;
    margin: 0 auto;
  }
}

.livesed {
  width: 100%;
  min-width: 1280px;
  background: #ffffff;
  margin-bottom: 80px;

  > div {
    width: 1280px;
    min-width: 1280px;
    margin: 0 auto;
  }
}

.qcode {
  position: fixed;
  width: 1rem;
  height: 1rem;
  /*border-radius: 50%;*/
  bottom: 1.5rem;
  right: 0.1rem;
}

.title___2jv0H {
  flex: 1 1;
  font-size: 26px;
  font-weight: 500;
  color: #333;
}

.footer_yybm {
  width: 60px;
  font-size: 12px;
  cursor: pointer;
}

.abc {
  position: relative;
}

.abc img {
  display: block;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  /*width: 7rem;*/
  /*margin: 0.25rem;*/
}

.mask {
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  font-size: 0.24rem;
  background: rgba(0, 0, 0, 0.5);
}

.rel {
  font-size: 0.28rem;

  .qrcode {
    width: 6.9rem;
    /*height: 3.57rem;*/
    background: #ffffff;
    top: 2.21rem;
    position: absolute;
    left: 0.32rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0.4rem 0.3rem;
    box-sizing: border-box;
    z-index: 11;

    p {
      text-align: center;
      font-size: 0.4rem;
    }
  }
}

.search {
  height: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0 0.3rem;
  box-sizing: border-box;
  background: #f7f7f7;

  > img {
    width: 2.79rem;
    height: 0.38rem;
  }

  > div {
    display: flex;
    width: 3.8rem;
    height: 0.7rem;
    border: 1px solid #ffb441;
    padding-left: 0.2rem;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 10px;
    margin-left: 0.32rem;
    font-size: 0.3rem;
    color: #ffb441;
    align-items: center;
    justify-content: center;

    img {
      width: 0.4rem;
      height: 0.37rem;
      margin-right: 0.15rem;
    }
  }
}

.content___1ZfD3 {
  width: 1280px;
  min-width: 1280px;
  /*padding-bottom: 24px;*/
  box-sizing: border-box;
  margin: 0 auto;
}

.backg {
  width: 100%;
  background: #f7f7f7;
  min-width: 1280px;
}

.nothing {
  width: 100%;
  background: #ffffff;
  /*padding-top: 2.64rem;*/
  box-sizing: border-box;
  text-align: center;

  img {
    width: 1.96rem;
    height: 1.28rem;
    display: inline-block;
    margin: 1.09rem auto 0px;
    /*width: 100%;*/
  }

  div {
    font-size: 0.26rem;
    color: #999999;
    text-align: center;
  }
}

.banner {
  /*width: 7.5rem;*/
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05),
    -3px 0 5px rgba(0, 0, 0, 0.05);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05), -3px 0 5px rgba(0, 0, 0, 0.05);
}

.titleWrapper___2qZKS {
  /*margin-top: 46px;*/
}

.item_list {
  overflow: hidden;
  margin-bottom: 20px;
  background: #f7f7f7;
}

.container_item {
  /*border: 1px solid #999999;*/
  /*-webkit-border-radius: 5px;*/
  /*padding: 10px;*/
  -moz-border-radius: 5px;
  border-radius: 5px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 232px;
  /*height: 207px;*/
  cursor: pointer;
  background: #fff;
  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  justify-content: space-between;

  .item_title {
    .title_time {
      color: #999999;
    }
  }

  .con {
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    padding: 10px;

    .con_right {
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .con_images {
      width: 212px;
      height: 120px;
      border-radius: 5px;
    }

    .con_title {
      font-size: 14px;
      color: #333;
      line-height: 22px;
      height: 44px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp: 2;
    }
  }

  .con_author {
    font-size: 12px;
    font-weight: 300;
    color: #999;
    min-height: 14px;
  }

  .con_org {
    font-size: 12px;
    color: #999;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.courseRecomItem___3hA2S {
  /*height: 207px;*/
}

.type_title {
  box-sizing: border-box;
}

.last {
  display: flex;
  justify-content: space-between;

  span:nth-of-type(1) {
    font-size: 12px;
    font-weight: 300;
    color: #999;
    min-height: 12px;
  }
}

.last,
.type_title {
  button {
    border-radius: 25px;
    color: #ffffff;
    border: none;
    outline: none;
  }
}

.footer_type {
  color: #ffb400;
}

.textColor {
  color: #2bcf4a;
}

.live_type {
  flex: 1 1;
  font-size: 26px;
  font-weight: 500;
  color: #007eff;
  margin-top: 26px;
  background: #f7f7f7;
}

.liveswill {
  border: 1px solid #e6e6e6;
  height: 280px !important;
  border-radius: 5px;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 232px;
  cursor: pointer;
  background: #fff;
  padding: 0 10px;

  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  -webkit-box-pack: justify;
  justify-content: flex-start;

  .con {
    margin-top: 6px;
  }

  .item_title {
    padding-top: 6px !important;
  }

  .con_images {
    width: 212px !important;
    height: 134px !important;
    border-radius: 5px !important;
  }

  .con_title {
    font-size: 14px !important;
    color: #333 !important;
    line-height: 18px !important;
    height: 39px !important;
  }

  .con_author {
    font-size: 12px !important;
    font-weight: 300 !important;
    color: #666666 !important;
    min-height: 14px !important;
    //margin-top: 5px !important;
  }

  .last {
    padding: 0px !important;
    box-sizing: border-box !important;
    margin-top: 6px !important;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/video/index.vue